import React, { useEffect, useRef } from 'react';

const ScriptEmbed = () => {
  const scriptRef = useRef(null);

  useEffect(() => {
    // Create a script element
    const script = document.createElement('script');
    script.src = "https://www.juicer.io/embed/lfcoindao-848c508f-b62a-4212-a7fb-977e7e92760e/embed-code.js?per=15";
    script.async = true;
    script.defer = true;

    // Append the script to the div
    if (scriptRef.current) {
      scriptRef.current.appendChild(script);
    }

    // Cleanup function to remove the script when the component unmounts
    return () => {
      if (scriptRef.current) {
        scriptRef.current.removeChild(script);
      }
    };
  }, []);

  return (
    <div ref={scriptRef}>
      {/* The script will be loaded here */}
    </div>
  );
};

export default ScriptEmbed;


